<script type="text/ecmascript-6">
    import DesignerQuestionSelectCompOptions from "../DesignerQuestionSelectCompOptions.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectCompOptions,
            SynsealTileQuestion
        ],
    }
</script>
